import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarTaxaImpostoModel } from "../models/taxaImposto/buscaTaxaImpostoModel";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalDeletarTaxaImposto, setPageTaxaImposto } from "../redux/slices/taxaImposto/taxaImpostoSlice";

export const cadastrarTaxaImposto = createAsyncThunk("/TaxaImposto/CadastrarTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/TaxaImposto/CadastrarTaxaImposto", payload.value);
    toastSucess("Taxa/Imposto cadastrado com sucesso");
    dispatch(setPageTaxaImposto("geral"));
    dispatch(setLoading(false));

  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarTaxaImposto = createAsyncThunk("/TaxaImposto/BuscarTaxaImposto", async (args: BuscarTaxaImpostoModel) => {
  try {
    const data = await api.get("/TaxaImposto/BuscarTaxaImposto", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarTaxaImposto = createAsyncThunk("/TaxaImposto/AtualizarTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/TaxaImposto/AtualizarTaxaImposto/", payload.value);
    toastSucess("Taxa/Imposto atualizada com sucesso");
    dispatch(setPageTaxaImposto("geral"));
    dispatch(setLoading(false));

  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarTaxaImpostoAtivo = createAsyncThunk("/TaxaImposto/AtualizarTaxaImpostoAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/TaxaImposto/AtualizarTaxaImpostoAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status de ativo da Imposto/Taxa foi atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarTaxaImposto = createAsyncThunk("/TaxaImposto/DeletarTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/TaxaImposto/DeletarTaxaImposto/", {
      params: { id: payload.value },
    });
    toastSucess("Taxa/Imposto removida com sucesso");
    dispatch(setModalDeletarTaxaImposto(false));
    dispatch(setLoading(false));

    dispatch(buscarTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
